import { render, staticRenderFns } from "./changyongGj.vue?vue&type=template&id=4b66fc7e&scoped=true"
import script from "./changyongGj.vue?vue&type=script&lang=js"
export * from "./changyongGj.vue?vue&type=script&lang=js"
import style0 from "./changyongGj.vue?vue&type=style&index=0&id=4b66fc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66fc7e",
  null
  
)

export default component.exports